<mat-form-field class="fuse-mat-no-subscript w-full" [ngClass]="classes" [formGroup]="form" [floatLabel]="floatLabel">
    <mat-label>{{ label }}</mat-label>
    <input type="text" matInput [required]="required" [imask]="mask" [unmask]="true" [placeholder]="placeholder"
        [formControlName]="controlName" *ngIf="!autoFocus" />

    <input type="text" matInput [required]="required" [imask]="mask" [unmask]="true" [placeholder]="placeholder"
        [formControlName]="controlName" appFocus *ngIf="autoFocus" />
</mat-form-field>